import React, { useEffect, useState } from "react";
import ProfileUnitView from "presentational/portfolio/ProfileUnitView";
import TXT from "presentational/common/multinational/TXT";
import config from "lib/fr-config";
import GaHelper from "lib/gaHelper";
import { withStore } from "store/storeHandler";
import { useHistory } from "react-router-dom";
import { withToken } from "lib/forceTokenRenewComponent";
import PropTypes from "prop-types";
import { getFullUrl, getEssentialUrl } from "lib/urlQueryParser";

const MAX_FOLLOW_USER_COUNT = config.followUser.MAX_COUNT;

OthersProfile.propTypes = {
  ownerName: PropTypes.string.isRequired
};

function OthersProfile(props) {
  const { ownerName } = props;
  const {
    hasLoggedIn,
    image,
    location,
    gender,
    isFollowing,
    myProfile,
    UserProfileActions,
    AppErrorActions,
    FollowUserListActions,
    NoticeModalActions
  } = props;
  const { getIdTokenWT } = props;
  const [nowOwnerName, setNowOwnerName] = useState(null);

  const history = useHistory();

  useEffect(() => {
    requestUserProfile();
  });

  const requestUserProfile = async () => {
    if (ownerName === nowOwnerName) return null;

    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;

    try {
      await UserProfileActions.changeUserProfile({ name: ownerName, idToken });
    } catch (error) {
      AppErrorActions.setFatalAppError(error);
      return null;
    }

    setNowOwnerName(ownerName);
  };

  const alreadyExceededFollowLimit = () => {
    const { followingNum } = myProfile;

    if (followingNum >= MAX_FOLLOW_USER_COUNT) return true;
    else return false;
  };

  const getButtonAttribute = attrType => {
    let returnData = null;

    if (!hasLoggedIn) {
      returnData = {
        btnText: <TXT name="btnCommonContained_loginRecommend" />,
        btnStyle: "soft",
        btnFunc: handleLogInClick,
        disabled: false
      }[attrType];
    } else if (isFollowing === "yes") {
      returnData = {
        btnText: <TXT name="btnCommonContained_unfollow" />,
        btnStyle: "soft",
        btnFunc: handleRelationClick,
        disabled: false
      }[attrType];
    } else if (isFollowing === "no") {
      returnData = {
        btnText: <TXT name="btnCommonContained_followRecommend" />,
        btnStyle: "bold",
        btnFunc: handleRelationClick,
        disabled: alreadyExceededFollowLimit()
      }[attrType];
    }

    if (typeof returnData === "undefined") {
      console.error(`wrong attrType : "${attrType}"`);
    }

    return returnData;
  };

  const handleLogInClick = () => {
    const accountPageUrl = getFullUrl({
      url: getEssentialUrl({ type: "account", allowRefParam: true })(),
      queryObj: {
        next: getEssentialUrl({ type: "portfolio" })(ownerName)
      }
    });
    history.push(accountPageUrl);

    GaHelper.setGAClickEvent({
      type: "logInRecommendationBtn",
      loc: "profileSection"
    });
  };

  const handleRelationClick = async () => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await UserProfileActions.changeRelation({ name: ownerName, idToken });
    } catch (error) {
      if (error.message === "UnknownUser" || error.message === "DeletedUser") {
        NoticeModalActions.openModal({
          content: <TXT name="msg_userDoesntExist" />
        });
      } else {
        AppErrorActions.setSafeAppError(error);
      }
    }
    FollowUserListActions.deleteAllData();
  };

  return (
    <div>
      <ProfileUnitView
        profileType="others"
        ownerName={ownerName}
        location={location}
        gender={gender}
        image={image}
        firstBtnText={getButtonAttribute("btnText")}
        firstBtnStyle={getButtonAttribute("btnStyle")}
        onFirstBtnClick={getButtonAttribute("btnFunc")}
        disabledFirstBtn={getButtonAttribute("disabled")}
      />
    </div>
  );
}

export default withToken(
  withStore({
    stateMap: {
      myAccount: ["hasLoggedIn"],
      userProfile: ["image", "location", "gender", "isFollowing", "myProfile"]
    },
    dispatchMap: ["userProfile", "appError", "followUserList", "noticeModal"]
  })(OthersProfile)
);
